import ComparePage from './CompareLayout';
import { CAYDA, ADV } from './caydaFacts';

const VsMarkerIo = () => (
  <ComparePage
    slug="marker-io"
    competitor="Marker.io"
    description="Marker.io alternative: Cayda pins feedback on your live site, invisible to visitors, with Jira, Asana and Linear on a $14 tier instead of $149. Free plan."
    hero="The Marker.io alternative that starts at $9, not $39."
    intro="Both tools let your team leave visual feedback on a live website. Cayda does it without a visible button on your site, without metering your page views, and without a $149 tier standing between you and Jira. Here is the comparison, number by number."
    verdict={[
      { label: 'Starting price', cayda: '$9/mo', other: '$39/mo, 3 users' },
      { label: 'Free plan', cayda: 'Yes, no clock', other: '15 day trial, 25 issues' },
      { label: 'Page views', cayda: 'Unmetered', other: '5,000/mo on Starter' },
      { label: 'Jira + issue sync', cayda: '$14 tier', other: '$149 tier' },
    ]}
    advantages={[
      ADV.invisible,
      ADV.pricing,
      { ...ADV.dashboard, body: 'Kanban and list views, filters by status, priority, assignee and note type, bulk actions, threaded comments and CSV export on Pro. Marker.io holds CSV export back to its $149 plan.' },
      ADV.capture,
    ]}
    cost={{
      note: 'Annual billing, per month. Marker.io pricing from marker.io/pricing, August 2026.',
      scenarios: [
        { label: 'Solo freelancer', detail: 'unlimited sites', cayda: 9, other: 39, caydaPlan: 'Pro, owner covered', otherPlan: 'Starter, 3 seats min' },
        { label: 'Team of five, Slack', detail: 'no page view cap on Cayda', cayda: CAYDA.proPrice(4), other: 47, caydaPlan: 'Pro + 4 members', otherPlan: 'Starter + 2 extra users' },
        { label: 'Team of five, Jira', detail: 'plus Asana, Linear, screen recording, guests', cayda: CAYDA.teamPrice(4), other: 149, caydaPlan: 'Team + 4 members', otherPlan: 'Team plan' },
      ],
    }}
    diagram="widget"
    features={{
      note: 'Cayda plan names in the Cayda column. Marker.io details from marker.io/pricing, August 2026.',
      rows: [
        ['Free plan', CAYDA.free, 'None'],
        ['Entry paid plan', CAYDA.pro, '$39 · 3 users · 10 projects'],
        ['Jira, Asana, Linear', CAYDA.team, '$149 tier'],
        ['Slack', 'Pro', 'Starter'],
        ['Websites on paid plans', 'Unlimited', '10 to 50'],
        ['Page view caps', 'None', '5,000 to 25,000/mo'],
        ['Visible to site visitors', 'Never', 'Feedback button'],
        ['Owner covered by base fee', true, false],
        ['Auto screenshot, browser, OS, viewport', true, true],
        ['Screen recording', 'Team', 'Session replay on $149 tier'],
        ['Kanban + list dashboard, bulk actions', true, 'Dashboard'],
        ['Client / guest reviewers', 'Team, no member fee', 'Free reporters'],
        ['CSV export', 'Pro', 'Team ($149)'],
        ['WordPress plugin, Shopify app', true, 'WordPress plugin'],
      ],
    }}
    approach={[
      'Marker.io is built around a feedback button that renders on the page so anyone visiting, including the public, can file a report. Its plans are sized by users, projects and monthly page views: Starter covers three users, ten projects and 5,000 page views; Team lifts that to fifteen users, fifty projects and 25,000 page views and is where issue sync with Jira, session replay and console capture live, at $149 a month.',
      'That model suits a product team collecting bug reports from end users on a couple of properties. Cayda is built for the team that owns the site: the layer is private, page views are never counted, paid plans have no site limit, and the tracker integrations sit on a $14 base fee.',
    ]}
    bottomLine={[
      'If you want your team and your clients leaving pinned notes on the real site, triaging them in a board, and pushing them into Slack, Jira, Asana or Linear, Cayda does that for $9 to $38 a month for most teams, with nothing showing to your visitors.',
      'The free plan has no trial clock, so the fastest way to decide is to add a site and click on it.',
    ]}
  />
);

export default VsMarkerIo;
